/**
 * Key of the root page transition. Only a switch between the auth shell and the
 * app shell changes it. Navigation inside the app keeps the same key, so the
 * sidebar and the rest of the shell stay mounted (P23 I1).
 */
export function rootTransitionKey(pathname: string): "auth" | "app" {
  // Only trigger a root-level transition when switching between major shells.
  if (pathname.startsWith("/login") || pathname.startsWith("/register")) {
    return "auth";
  }
  return "app";
}
